export default (mapping, element) => {
	let match;
	if (element instanceof Element) {
		match = mapping.find(({ selector }) => {
			let properties;
			if (typeof selector === 'string') {
				properties = element.matches(selector);
			} else if (selector instanceof Array) {
				properties = selector.find((sel) => element.matches(sel));
			}
			return properties;
		});
	}
	return match;
};
